import localForage from 'localforage'


export function isSupported() {
  return !__SERVER__ && localForage
}


export function getLastActivity() {
  if (__SERVER__) {
    return Promise.resolve()
  }

  if (localForage) {
    return localForage.getItem('lastActivity')
      .then(json => JSON.parse(json))
      .catch(console.error)
  }
  else {
    console.warn('Localforage not working on this client')
    return Promise.resolve()
  }
}


export function resetLastActivity() {
  if (__SERVER__) {
    return Promise.resolve()
  }

  if (localForage) {
    return localForage.setItem('lastActivity', JSON.stringify(new Date()))
      .catch(console.error)
  }
  else {
    console.warn('Localforage not working on this client')
    return Promise.resolve()
  }
}


export default {
  isSupported,
  getLastActivity,
  resetLastActivity
}
